export const toastConfig = {
  position: "bottom-right",
  reverseOrder: true,
  toastOptions: {
    className: 'bg-gray-900 text-white',
    duration: 4000,
    style: {
      border: '1px solid rgba(255, 255, 255, 0.1)',
      padding: '16px',
      color: '#fff',
    },
  },
}; 